import { Footer as Container } from './styles'

export function DrawerFooter({ children, name, ...rest }) {
  return <Container {...rest}>{children}</Container>
}
